import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

export interface CopyActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const CopyAction: React.FC<CopyActionProps> = ({ className, ...buttonProps }) => (
  <button {...buttonProps} type="button" className={className}>
    <FormattedMessage id="actions.copy" />
  </button>
);
